export default __webpack_public_path__ + "static/media/848.00f31ce0.png";